/**
 * Converts a dashboard date-only value into a Date for calendar controls.
 *
 * Date-only strings must not be passed to `new Date(string)`: ECMAScript
 * interprets them as UTC, which can display the previous day locally.
 */
export function dateOnlyToLocalDate(date: string): Date {
  const [year, month, day] = date.split("-").map(Number);

  return new Date(year, month - 1, day);
}
